<template>
    <div class="c-base-checkbox">
        <ion-checkbox
            slot="start"
            @ionChange="$emit('input', $event.detail.checked)"
            :value="value"
            :checked="value"
            v-if="label === '' && !hasSlot"
            :name="value"
            :disabled="disabled"
        ></ion-checkbox>
        <div v-else>
            <ion-item :lines="lines">
                <ion-checkbox
                    slot="start"
                    @ionChange="$emit('input', $event.detail.checked)"
                    :value="value"
                    :checked="value"
                    :name="value"
                    :disabled="disabled"
                ></ion-checkbox>
                <ion-label text-wrap v-html="label" v-if="!hasSlot">
                </ion-label>
                <ion-label text-wrap v-else>
                    <slot></slot>
                </ion-label>
                <ion-button
                    slot="end"
                    v-if="info !== ''"
                    @click.stop="openInfoAlert()"
                    fill="clear"
                    color="dark"
                >
                    <ion-icon
                        name="information-circle-outline"
                        slot="icon-only"
                    ></ion-icon>
                </ion-button>
            </ion-item>
            <input-error :id="id"></input-error>
        </div>
    </div>
</template>

<script>
import InputError from "./InputError";

export default {
    components: {
        InputError,
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        lines: {
            type: String,
            required: false,
            default: undefined,
        },
        info: {
            type: String,
            required: false,
            default: "",
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        openInfoAlert() {
            this.$ionic.alertController
                .create({
                    header: "Information",
                    message: this.info,
                    buttons: ["Ok"],
                })
                .then((a) => {
                    a.present();
                });
        },
    },
    computed: {
        hasSlot() {
            let result = false;
            if (this.$slots.default && this.$slots.default.length > 0) {
                result = true;
            }
            return result;
        },
    },
};
</script>

<style lang="scss"></style>
